"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgDelete(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M18 4v11a1 1 0 01-1 1H7a1 1 0 01-1-1V4zm-3-4a1 1 0 01.993.883L16 1h3a1 1 0 011 1v1H4V2a1 1 0 011-1h3a1 1 0 011-1z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Delete')(SvgDelete);
//# sourceMappingURL=Delete.js.map